export const fonts = {
    regularFont:
        "BrandonTextWeb-Regular,Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    boldFont:
        "BrandonTextWeb-Bold,Helvetica Neue, Helvetica, Roboto, Arial,sans-serif",
    mediumFont:
        "BrandonTextWeb-Medium,Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    lightFont:
        "BrandonTextWeb-Light,Helvetica Neue,Helvetica, Roboto, Arial, sans-serif"
};

export const fontSizes = {
    xxlarge: 22,
    large: 18,
    medium: 16,
    small: 14,
    xsmall: 12,
    xxsmall: 10,
    xxxsmall: 8,
}

